module.exports = __webpack_public_path__ + "static/media/user.49ff2064.svg";